export default __webpack_public_path__ + "images/0x3355df6d4c9c3035724fd0e3914de96a5a83aaf4.png";